import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2, Newspaper } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios.get(`${API}/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setMissing(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <PageHeader />
      <main className="px-6 sm:px-12 lg:px-20 pt-28 sm:pt-36 pb-24" data-testid="article-detail-page">
        {!article && !missing && <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-[#FF4E00]" /></div>}
        {missing && (
          <div className="max-w-xl mx-auto text-center rounded-3xl border border-[#0D1117]/10 bg-[#FFFFFF] p-12">
            <h1 className="font-serif text-3xl text-[#0D1117]">Article not found.</h1>
            <Link to="/articles" className="mt-6 inline-flex font-mono text-xs uppercase tracking-[0.2em] text-[#FF4E00]">Back to articles</Link>
          </div>
        )}
        {article && (
          <article className="max-w-4xl mx-auto">
            <Link to="/articles" data-testid="article-back-link" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280] hover:text-[#FF4E00] transition-colors mb-8">
              <ArrowLeft className="w-3.5 h-3.5" /> All Articles
            </Link>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4E00] mb-5 flex items-center gap-3">
              <Newspaper className="w-4 h-4" /> {article.category}
            </p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#0D1117] tracking-tight leading-tight mb-6" data-testid="article-title">
              {article.title}
            </h1>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#6B7280] mb-8">
              {article.author_name} · {new Date(`${article.publish_date}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })} · {article.read_time} min read
            </p>
            {article.cover_url && (
              <img src={`${process.env.REACT_APP_BACKEND_URL}${article.cover_url}`} alt={article.title} className="w-full aspect-[16/8] object-cover rounded-3xl border border-[#0D1117]/10 mb-10" data-testid="article-cover" />
            )}
            <div className="rounded-3xl border border-[#0D1117]/10 bg-[#FFFFFF] p-7 sm:p-10" data-testid="article-body">
              {article.body.split(/\n{2,}/).map((paragraph) => (
                <p key={paragraph.slice(0, 40)} className="text-base text-[#374151] leading-relaxed mb-6 last:mb-0 whitespace-pre-line">
                  {paragraph}
                </p>
              ))}
            </div>
          </article>
        )}
      </main>
      <Footer />
    </div>
  );
}
